import { Exclude, Expose } from 'class-transformer';

export const BLOCK_CQL_DEFAULT: string = 'true';

@Exclude()
export class BlockCqlSettings {
  @Expose()
  cql: string = BLOCK_CQL_DEFAULT;
}
